/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';
    function isUndefined(value) {
        return value === undefined;
    }

    function isFunction(value) {
        return typeof value === 'function';
    }

    return function(template, values) {
        return template.replace(/\{ *([\w_]+) *\}/g, function(match, key) { //eslint-disable-line
            var value = values[key];
            if (isUndefined(value)) {
                return '{' + key + '}';
            } else if (isFunction(value)) {
                return value(key);
            }
            return value;
        });
    };
});



// WEBPACK FOOTER //
// ./requester/template.js